import { createRouter, createWebHashHistory } from 'vue-router'
import { listTools } from '@/config/tools'

const toolRoutes = listTools
  .filter((tool) => tool.isActive && tool.component && tool.routeName)
  .map((tool) => ({
    path: `tools/${tool.slug}`,
    name: tool.routeName!,
    component: tool.component!
  }))

const routes = [
  {
    path: '/',
    component: () => import('@/views/HomeView.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        // 空组件，主页欢迎内容由 HomeView 内部的 v-if 渲染
        component: { render: () => null }
      },
      ...toolRoutes,
      {
        path: 'native/:id',
        name: 'NativeApp',
        component: () => import('@/views/nativeApps.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

const pageTitles: Record<string, string> = {
  Home: '残雪工具分享',
  ...Object.fromEntries(
    listTools
      .filter((tool) => tool.routeName && tool.pageTitle)
      .map((tool) => [tool.routeName!, tool.pageTitle!])
  )
}

router.beforeEach((to, from, next) => {
  if (to.name !== 'NativeApp') {
    document.title = pageTitles[to.name as string] || '残雪工具分享'
  }
  next()
})

export default router
